import React from 'react'
import { Outlet, useNavigate } from 'react-router-dom';
import { CustomTab } from '../../../components'
import { Box } from '@mui/material';

const TaskTabScreen = () => {
  const navigate = useNavigate();
  return (
    <Box mt={-2}>
      <CustomTab
        base={'/admin/tareas'}
        panels={[
          {
            name: "Tareas",
            route: '/admin/tareas/listado',
            onChange: () => navigate('listado'),
            content: <Outlet />
          },
          {
            name: "Aclaraciones",
            route: '/admin/tareas/aclaraciones',
            onChange: () => navigate('aclaraciones'),
            content: <Outlet />
          },
        ]}
      />
    </Box>
  )
}

export default TaskTabScreen